import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { axiosInstance } from '@appblocks/frontend/client/utils';
import { Link, useHistory, useParams } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PageAccount from '@appblocks/frontend/client/Pages/PageAccount';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import { BsThreeDotsVertical } from 'react-icons/bs';
import DataPaginationRenderer from '@appblocks/frontend/cloudclient/Components/DataPaginationRenderer';
import PageWorkspaceSettings from '@appblocks/frontend/client/Pages/PageWorkspaceSettings';

export default function PageCloudSettings(props) {
    const workspaces = useSelector(state => state.workspaces);
    const history = useHistory();
    const { setting } = useParams();
    const [activeTab, setActiveTab] = useState(setting || 'general');

    const selectTab = (k) => {
        setActiveTab(k);
        history.push(`/settings/${k}`);
    };

    useEffect(() => {
        if (!setting
            || (setting === 'workspace' && !workspaces.currentWorkspace)) {
            history.replace('/settings/profile');
        }
    }, [setting]);


    return (
        <>
            <div className="container pt-3">
                <h3>Settings</h3>
                <div className="row">
                    <Tab.Container
                        defaultActiveKey="general"
                        activeKey={activeTab}
                    >
                        <Row>
                            <Col md={2}>
                                <Nav
                                    variant="pills"
                                    className="flex-column"
                                    onSelect={selectTab}
                                >
                                    {/* <Nav.Item>
                                        <Nav.Link eventKey="general">General</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="quotas">Quotas</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="rate">Rate Limits</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="billing">Billing</Nav.Link>
                                    </Nav.Item> */}
                                    <Nav.Item>
                                        <Nav.Link eventKey="profile">Profile</Nav.Link>
                                    </Nav.Item>
                                    {
                                        workspaces.currentWorkspace
                                        && (
                                            <Nav.Item>
                                                <Nav.Link eventKey="workspace">Workspace</Nav.Link>
                                            </Nav.Item>
                                        )
                                    }
                                </Nav>
                            </Col>
                            <Col md={10}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="general">
                                        <div className="card">
                                            <div className="card-header">
                                                General
                                            </div>
                                            <div className="card-body">
                                                General Settings
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="quotas">
                                        <div className="card">
                                            <div className="card-header">
                                                Quotas
                                            </div>
                                            <div className="card-body">
                                                Current Quotas
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="rate">
                                        <div className="card">
                                            <div className="card-header">
                                                Rate Limiting
                                            </div>
                                            <div className="card-body">
                                                Rate Limiting Explanation
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="billing">
                                        <div className="card">
                                            <div className="card-header">
                                                Billing
                                            </div>
                                            <div className="card-body">
                                                Billing Details and Plan
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="profile">
                                        <div className="card">
                                            <div className="card-header">
                                                Profile
                                            </div>
                                            <div className="card-body">
                                                <PageAccount />
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    {
                                        workspaces.currentWorkspace
                                        && (
                                            <Tab.Pane eventKey="workspace">
                                                <div className="card">
                                                    <div className="card-header">
                                                        Workspace
                                                    </div>
                                                    <div className="card-body">
                                                        <PageWorkspaceSettings />
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                        )
                                    }
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>

                </div>
            </div>
        </>
    );
}
